import type { ErrorType } from "./types";

export const FORM_PATH = "/r/:linkToken";
export const PENDING_PATH = "/r/:linkToken/pending";
export const CONFIRM_PATH = "/confirm";
export const THANKYOU_PATH = "/thank-you";
export const ERROR_PATH = "/error/:type";
export const EDIT_PATH = "/r/:editToken/edit";
export const EDIT_PENDING_PATH = "/r/:editToken/edit/pending";
export const CONFIRM_EDIT_PATH = "/confirm-edit";
export const REVOKE_PATH = "/revoke/:revokeToken";
export const DISPUTE_PATH = "/dispute/:evidenceToken";
export const PRIVACY_PATH = "/privacy";
export const IMPRINT_PATH = "/imprint";

export function toFormPath(linkToken: string): string {
  return `/r/${encodeURIComponent(linkToken)}`;
}

export function toPendingPath(linkToken: string): string {
  return `/r/${encodeURIComponent(linkToken)}/pending`;
}

export function toConfirmPath(token: string): string {
  return `/confirm?token=${encodeURIComponent(token)}`;
}

export function toEditPath(editToken: string): string {
  return `/r/${encodeURIComponent(editToken)}/edit`;
}

export function toEditPendingPath(editToken: string): string {
  return `/r/${encodeURIComponent(editToken)}/edit/pending`;
}

export function toConfirmEditPath(token: string): string {
  return `/confirm-edit?token=${encodeURIComponent(token)}`;
}

export function toRevokePath(revokeToken: string): string {
  return `/revoke/${encodeURIComponent(revokeToken)}`;
}

export function toDisputePath(evidenceToken: string): string {
  return `/dispute/${encodeURIComponent(evidenceToken)}`;
}

export function toThankYouPath(opts: {
  firstName?: string;
  companyName?: string;
  rating?: number;
}): string {
  const p = new URLSearchParams();
  if (opts.firstName) p.set("name", opts.firstName);
  if (opts.companyName) p.set("company", opts.companyName);
  if (opts.rating != null) p.set("rating", String(opts.rating));
  const q = p.toString();
  return q ? `/thank-you?${q}` : "/thank-you";
}

export function toErrorPath(
  type: ErrorType,
  opts: { date?: string; companyName?: string } = {}
): string {
  const p = new URLSearchParams();
  if (opts.date) p.set("date", opts.date);
  if (opts.companyName) p.set("company", opts.companyName);
  const q = p.toString();
  return `/error/${type}${q ? `?${q}` : ""}`;
}
